import none from '../../img/leoLogo.png'

export const burgerAndSandwich=[
    {
      "id": "61",
      "title": "برگر ساده",
      "desciption": "",
      "price": "215",
      "image": none
    },
    {
      "id": "62",
      "title": "چیلی برگر",
      "desciption": "",
      "price": "255",
      "image": none
    },
    {
      "id": "63",
      "title": "فرایز برگر",
      "desciption": "",
      "price": "265",
      "image": none
    },
    {
      "id": "64",
      "title": "ژامبون تنوری",
      "desciption": "",
      "price": "269",
      "image": none
    },
    {
      "id": "65",
      "title": "ماشروم برگر",
      "desciption": "",
      "price": "289",
      "image": none
    },
    {
      "id": "66",
      "title": "لءو",
      "desciption": "",
      "price": "385",
      "image": none
    },
    {
      "id": "67",
      "title": "ساندویچ چیکن",
      "desciption": "",
      "price": "298",
      "image": none
    },
    {
      "id": "68",
      "title": "ساندویچ هندی",
      "desciption": "",
      "price": "205",
      "image": none
    },
    {
      "id": "69",
      "title": "چیز برگر",
      "desciption": "",
      "price": "290",
      "image": none
    }
  ]